import React from "react";
import { Dropdown, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Error, Success } from "./Messages/Messages";
import { generalErrorAlert } from "./GeneralErrorAlert";
import { LANGUAGE_OPTIONS, getLanguageOption } from "./Language/languageOptions";
import axios from "axios";

const { Text } = Typography;

function ChangeLanguageDropdown() {
  const { t, i18n } = useTranslation("dashboard");

  const updateLanguageInDb = async language => {
    try {
      await axios
        .put(
          `${process.env.REACT_APP_BACKEND_URL}/users/update-language`,
          {
            language
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            Success(res.data.successMessage);
          } else {
            Error(res.data.errorMessage);
          }
        })
        .catch(err => {
          generalErrorAlert(err);
        });
    } catch (error) {
      generalErrorAlert(error);
    }
  };

  const handleMenuClick = ({ key }) => {
    i18n.changeLanguage(key);
    updateLanguageInDb(key);
  };

  const current = getLanguageOption(i18n.language);
  const isActive = lang => current.code === lang;

  const items = [
    {
      key: "1",
      type: "group",
      label: t("System Language"),
      children: LANGUAGE_OPTIONS.map(lang => ({
        key: lang.code,
        label: (
          <Space>
            <img className="language-country-flag" alt={lang.short} src={lang.flag} />
            <Text strong={isActive(lang.code)}>{lang.name}</Text>
            {isActive(lang.code) && (
              <Text type="success" style={{ marginInlineStart: "8px", fontSize: "12px" }}>
                ✓ {lang.activeLabel}
              </Text>
            )}
          </Space>
        )
      }))
    }
  ];

  return (
    <div className="language-dropdown-container">
      <Dropdown
        menu={{
          items,
          onClick: handleMenuClick,
          selectedKeys: [current.code]
        }}
        placement="bottomRight"
        arrow={{ pointAtCenter: true }}
        trigger={["click"]}
      >
        <button
          type="button"
          className="language-selector"
          aria-label={t("System Language")}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "6px",
            border: 0,
            background: "transparent",
            color: "inherit",
            cursor: "pointer"
          }}
        >
          <Text style={{ margin: 0, color: "inherit" }}>{current.short}</Text>
        </button>
      </Dropdown>
    </div>
  );
}

export default ChangeLanguageDropdown;
